/**
 * MIRA Progress Component
 * Wraps Shadcn Progress with MIRA design system styles
 */

import React from 'react';
import { Progress as ShadcnProgress } from '@/components/ui/progress';
import { cn } from '@/lib/utils';
import styles from '@/styles/components/progress.module.css';

export const Progress = React.forwardRef(
  ({ className, ...props }, ref) => {
    return (
      <ShadcnProgress
        ref={ref}
        className={cn(styles.miraProgress, className)}
        {...props}
      />
    );
  }
);

Progress.displayName = 'MiraProgress';
